<script setup>
import CloseIcon from '@assets/icons/close.svg';

const emit = defineEmits(['remove']);

defineProps({
    title: {
        type: String,
        required: true,
    },
});

const onClick = () => emit('remove');
</script>

<template>
    <button
        type="button"
        class="btn btn-sm bg-base-200/30 border-none hover:bg-base-200"
        :aria-label="$t('shop.remove_filter', { filter: title })"
        @click="onClick"
    >
        {{ title }} <CloseIcon class="w-4 h-4" />
    </button>
</template>
